import { makePublishHelper, makeSubscribeHelper } from '../helpers-creators';

const schema = {};

export const eventClosed = makePublishHelper(
  'eventClosed',
  'wh.common.event.ui.header.deposit.closed',
  schema,
);

export const onEventClosed = makeSubscribeHelper(
  'onEventClosed',
  'wh.common.event.ui.header.deposit.closed',
  schema,
);
